<template>
  <portal to="modal-destination" class="unselectable">
    <div class="relative h-screen w-screen  " v-if="isShowLinkEditorModal">
      <div
        class="aha-modal__backdrop"
        @click="hideModal()"
      />
      <div
        class=" link-modal"
      >
        <div class="flex justify-between align-middle mb-4 z-10">
          <div class="font-bold text-base">
            Insert/ Edit Link
          </div>
          <aha-icon
            name="close"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            @click="hideModal"
            class="cursor-pointer text-base-80"
          />
        </div>
        <div class="space-y-3">
          <div class="space-y-1">
            <div>URL</div>
            <aha-input
              autofocus
              v-model="link"
              placeholder="Link input"
              @keyup.enter="saveLink"
            />
            <div class="mt-1 text-sm text-red-100" v-if="!isValidLink">
              Please enter a valid link
            </div>
          </div>
          <div class="space-y-1">
            <div>Text to display</div>
            <aha-input
              v-model="textDisplay"
              placeholder="Text to display"
              @keyup.enter="saveLink"
            />
          </div>
          <div class="space-y-1">
            <div>Open link in...</div>
            <aha-select v-model="target">
              <aha-select-option
                value="_self"
              >
                {{ $i18nPresenter.t('Current window') }}
              </aha-select-option>
              <aha-select-option
                value="blank"
              >
                {{ $i18nPresenter.t('New window') }}
              </aha-select-option>
            </aha-select>
          </div>

          <div class="flex justify-end align-middle toolbox-action ">
            <div class="flex space-x-3">
              <aha-button @click="hideModal" variant="base">
                Cancel
              </aha-button>
              <aha-button @click="saveLink" :disabled="!isValidLink">
                Save
              </aha-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </portal>
</template>
<script>
import { mapState } from 'vuex'
import configs from '@/config'

export default {
  data() {
    return {
      link: '',
      target: '_self',
      textDisplay: '',
    }
  },
  computed: {
    ...mapState({
      isShowLinkEditorModal: (state) => state.isShowLinkEditorModal,
    }),
    isValidLink() {
      if (this.link.length === 0) {
        return true
      }
      // http text have 1 one character
      if ((this.link.match(/http/g) || []).length > 1) {
        return false
      }
      return this.link.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g)
    },
  },
  watch: {
    isShowLinkEditorModal() {
      if (this.isShowLinkEditorModal) {
        this.getLinkInFakeDom()
      }
    },
  },
  mounted() {
    document.addEventListener('keyup', (e) => {
      if (configs.EXIT_KEYS.includes(e.code)) {
        this.hideModal()
      }
    })
  },
  destroyed() {
    document.removeEventListener('keyup', (e) => {
      if (configs.EXIT_KEYS.includes(e.code)) {
        this.hideModal()
      }
    })
  },
  methods: {
    domSelection() {
      return document.querySelector('.fake-selection')
    },
    removeLink() {
      this.domSelection().closest('a').outerHTML = this.domSelection().textContent
      this.hideModal()
    },
    getLinkInFakeDom() {
      if (this.domSelection()) {
        const hrefDom = this.domSelection().closest('a')
        this.textDisplay = this.domSelection().textContent
        if (hrefDom) {
          this.link = hrefDom.getAttribute('href')
          this.target = hrefDom.getAttribute('target')
        }
      }
    },

    hideModal() {
      this.$store.state.isShowLinkEditorModal = false
      this.resetState()
    },
    resetState() {
      this.link = ''
      this.target = '_self'
      this.textDisplay = ''
    },
    formatHttp(text) {
      // if text is not a link, return https
      if (!text.includes('http')) {
        return `https://${text}`
      }
      return text
    },
    saveLink() {
      if (!this.isValidLink) {
        return
      }
      const selectionDoms = document.querySelectorAll('.fake-selection')
      Array.from(selectionDoms).map((selectionDom) => {
        const a = document.createElement('a')
        a.innerHTML = this.textDisplay
        if (this.link.length === 0) {
          if (selectionDom.closest('a')) {
            selectionDom.closest('a').outerHTML = selectionDom.innerHTML
          }
        }
        if (this.link.length > 0) {
          a.type = 'link'
          a.href = this.formatHttp(this.link)
          a.classList.add('text-hyper-link')
          a.target = this.target
          selectionDom.outerHTML = a.outerHTML
          return null
        }
        selectionDom.textContent = this.textDisplay

        return null
      })

      this.hideModal()
    },

    sanitize(url, protocols) {
      const anchor = document.createElement('a')
      anchor.href = url
      const protocol = anchor.href.slice(0, anchor.href.indexOf(':'))
      return protocols.indexOf(protocol) > -1
    },
  },

}
</script>
<style lang="scss" scoped>
.unselectable {
  -khtml-user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.link-modal{
  @apply   rounded-md  w-1/4 z-10 flex flex-col absolute top-1/2 left-1/2 bg-base-0 shadow-2xl border border-base-30 p-4;
  transform: translate(-50%, -50%);
}
.aha-modal__backdrop{
  @apply absolute inset-0;
}
</style>
